// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QAesj","hidden":"styles_hidden__9YZ3x"};